import { useTranslation } from "react-i18next";

import { Link } from "../lib/router";
import { ProfileAvatar } from "./ProfileAvatar";
import { useAppStore } from "../lib/store";
import { getThemeColors } from "../lib/theme";

export function AccountLink() {
  const auth = useAppStore((state) => state.auth);
  const name = useAppStore((state) => state.name);
  const isDark = useAppStore((state) => state.isDark);
  const theme = getThemeColors(isDark);
  const { t } = useTranslation();

  if (!auth) return null;

  if (auth.isAnonymous) {
    return (
      <Link
        to="/login"
        data-testid="sign-in-link"
        aria-label={t("login.signIn")}
        className={`flex h-8 items-center gap-2 rounded-lg border px-3 text-sm font-medium whitespace-nowrap hover:opacity-80 ${theme.bgSecondary} ${theme.border} ${theme.text}`}
      >
        <svg
          className="h-4 w-4 shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
          />
        </svg>
        {t("login.signIn")}
      </Link>
    );
  }

  return (
    <Link
      to="/account"
      data-testid="account-link"
      aria-label={t("account.open")}
      className={`flex h-8 max-w-44 items-center gap-2 rounded-lg border px-3 text-sm font-medium whitespace-nowrap hover:opacity-80 ${theme.bgSecondary} ${theme.border} ${theme.text}`}
    >
      <ProfileAvatar image={auth.image} name={auth.name} size="sm" />
      <span className="truncate">{name}</span>
    </Link>
  );
}
